import React from "react";
import { Route, Routes } from "react-router-dom";

import ServiceQueue from "@/components/screens/ServiceQueue";
import ServiceQueueFormPage from "@/components/screens/ServiceQueueFormPage";
import { SERVICE_QUEUE_FORM_MESSAGES } from "@/messages/service-queue/service-queue-form.messages";
import { SERVICE_QUEUE_MESSAGES } from "@/messages/service-queue/service-queue.messages";

const ServiceQueuePage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<ServiceQueue messages={SERVICE_QUEUE_MESSAGES} />} />
      <Route
        path="/create/:lang"
        element={<ServiceQueueFormPage messages={SERVICE_QUEUE_FORM_MESSAGES} />}
      />
      <Route
        path="/update/:serviceQueueId/:lang"
        element={<ServiceQueueFormPage messages={SERVICE_QUEUE_FORM_MESSAGES} />}
      />
      <Route
        path="/view/:serviceQueueId/:lang"
        element={<ServiceQueueFormPage messages={SERVICE_QUEUE_FORM_MESSAGES} isViewing />}
      />
      <Route path="/" element={<ServiceQueue messages={SERVICE_QUEUE_MESSAGES} />} />
    </Routes>
  );
};

export default ServiceQueuePage;
